import App from "@frog/source/models/App.js"
import Tiled from "@frog/source/utility/integration/Tiled.js"
import Random from "@frog/source/utility/Random.js"
import * as PlotSteps from "@frog/source/data/plot/steps.js"
import * as PlotConditions from "@frog/source/data/plot/conditions.js"
import * as PlotScripts from "@frog/source/data/plot/scripts.js"
import Navigation from "@frog/source/models/Navigation.js"
import Zone from "@frog/source/models/Zone.js"

const world = Tiled.parse({
    "tilemap": require("./tiles.json"),
    "tileset": require("@frog/source/data/levels/vmenezio.tileset.json"),
})
world.spots = require("./spots.json")

export default {
    "slug": "r4",
    "stage": {
        "image": require("./tiles.png"),
        "units": require("./units.json"),
        "world": world,
        "text": function(stage) {
            const remainingUnits = Object.values(stage.units).filter((unit) => {
                return unit.affiliation != "good"
                    && unit.type != "spot"
                    && unit.hasBeenRemoved != true && unit.isDead != true
                    && Zone.isInBounds(stage.encounters[stage.currentEncounterKey].zone, unit.position)
            })
            return "Defeat " + remainingUnits.length + " unit" + (remainingUnits.length != 1 ? "s" : "")
        },
        "conditions": [
            {
                "type": "turn:0:start",
                "events": [
                    PlotSteps.PlayAudio("Music:Combat"),
                    // // TODO: GET THIS TO WORK ACROSS MANY ENCOUNTERS
                    // // OR LET THEM PREPARE!!! AND PICK WHO GOES WHERE.
                    // PlotSteps.SpawnPlayerPartyScript(),
                ]
            },
            {
                "type": "condition",
                "isWinCondition": true,
                "condition": (stage) => {
                    return stage.currentEncounterKey == 1
                        && PlotConditions.areAllAffiliatedUnitsDefeated(stage, {"affiliation": "bad"})
                },
                "events": [
                    PlotSteps.HealPlayerPartyScript(),
                    PlotSteps.MoveEncounterScript({"nextEncounterKey": 2, "spotTag": "top-spawn", "doNotMoveCamera": true}),
                    PlotSteps.JumpToDifferentChapterEncounter({"nextEncounterKey": 5}),
                ]
            },
            {
                "type": "condition",
                "isWinCondition": true,
                "condition": (stage) => {
                    return stage.currentEncounterKey == 5
                        && PlotConditions.areAllAffiliatedUnitsDefeated(stage, {"affiliation": "bad"})
                },
                "events": [
                    PlotSteps.HealPlayerPartyScript(),
                    PlotSteps.MoveEncounterScript({"nextEncounterKey": 4, "spotTag": "bottom-spawn", "doNotMoveCamera": true}),
                    PlotSteps.JumpToDifferentChapterEncounter({"nextEncounterKey": 2}),
                ]
            },
            {
                "type": "condition",
                "isWinCondition": true,
                "condition": (stage) => {
                    return stage.currentEncounterKey == 2
                        && PlotConditions.areAllAffiliatedUnitsDefeated(stage, {"affiliation": "bad"})
                },
                "events": [
                    PlotSteps.HealPlayerPartyScript(),
                    PlotSteps.MoveEncounterScript({"nextEncounterKey": 3, "spotTag": "top-spawn", "doNotMoveCamera": true}),
                    PlotSteps.JumpToDifferentChapterEncounter({"nextEncounterKey": 4}),
                ]
            },
            {
                "type": "condition",
                "isWinCondition": true,
                "condition": (stage) => {
                    return stage.currentEncounterKey == 4
                        && PlotConditions.areAllAffiliatedUnitsDefeated(stage, {"affiliation": "bad"})
                },
                "events": [
                    PlotSteps.HealPlayerPartyScript(),
                    PlotSteps.MoveEncounterScript({"nextEncounterKey": 3, "spotTag": "bottom-spawn", "doNotMoveCamera": true}),
                    PlotSteps.JumpToDifferentChapterEncounter({"nextEncounterKey": 3}),
                ]
            },
            {
                "type": "condition",
                "isWinCondition": true,
                "condition": (stage) => {
                    return stage.currentEncounterKey == 3
                        && PlotConditions.areAllAffiliatedUnitsDefeated(stage, {"affiliation": "bad"})
                },
                "events": [
                    PlotSteps.ChapterSuccessClassic(),
                    {"func": () => Navigation.go("/games/war/chapters/r5")},
                ]
            },
            // {
            //     "type": "condition",
            //     "condition": function(stage) {
            //         return PlotConditions.areAllAffiliatedUnitsDefeated(stage, {"affiliation": "good"})
            //     },
            //     "events": [
            //         PlotSteps.ChapterFailure(),
            //         {"func": () => App.game.chapter.restart()},
            //     ]
            // }
        ]
    },
}
